import { useTranslation } from 'react-i18next';
import type { IAnalyticsTrendProps } from './IAnalyticsTrendProps';

/** «Створено й завершено · 8 тижнів» (прототип v4): пара стовпчиків на тиждень (висота — частка від найбільшого), підписи тижнів і ключ. */
export function AnalyticsTrend({ weeks }: IAnalyticsTrendProps) {
  const { t } = useTranslation();
  const max = Math.max(1, ...weeks.flatMap((w) => [w.created, w.completed]));
  const height = (n: number) => `${Math.round((n / max) * 100)}%`;
  return (
    <section className="an-card">
      <div className="an-card__title">{t('modBody.dash.trend')}</div>
      <div className="an-trend">
        {weeks.map((w) => (
          <div key={w.ago} className="an-trend__week" title={t('modBody.dash.trendTip', { created: w.created, completed: w.completed })}>
            <div className="an-trend__bars">
              <span className="an-trend__bar an-created" style={{ height: height(w.created) }} />
              <span className="an-trend__bar an-completed" style={{ height: height(w.completed) }} />
            </div>
            <span className="an-trend__label">{w.ago ? t('modBody.dash.weeksAgo', { n: w.ago }) : t('modBody.dash.thisWeek')}</span>
          </div>
        ))}
      </div>
      <div className="an-key">
        <span className="an-key__item"><span className="an-key__swatch an-created" />{t('modBody.dash.created')}</span>
        <span className="an-key__item"><span className="an-key__swatch an-completed" />{t('modBody.dash.completed')}</span>
      </div>
    </section>
  );
}
